// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./PickPackConfirmItemPageStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { BlueGradientHeader } from "../../index";
import { PageWrapper } from "../../index";
import { GreyButton } from "../../index";
import { ScanContentBar } from "../ScanContentBar";
import EditIcon from '@mui/icons-material/Edit';
import { WhiteContentBar } from "../WhiteContentBar";
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
export const PickPackConfirmItemPage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, data, scanContentBarText, isConfirmAllExist } = props;
    const [listData, setListData] = React.useState(data);
    React.useEffect(() => {
        setListData(data);
    }, [data]);
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(BlueGradientHeader, { type: "smallWithSub", showScanner: true, previewHeight: previewHeight },
                    React.createElement("p", null, "Pick and Pack"),
                    React.createElement("sub", null,
                        "Order - ",
                        React.createElement("b", null, "2286")))),
            React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentTopRadius, style: { height: previewHeight - 90 - 50 + 10 } },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(WhiteContentBar, { data: { leftContent: "Item / Batch", rightContent: "B10000 / B1-00078" } })),
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(ScanContentBar, { text: scanContentBarText || PickPackConfirmItemPage.defaultProps.scanContentBarText, applyBorderRadius: false })),
                    isConfirmAllExist &&
                        React.createElement(Grid, { item: true, md: 12, className: classes.confirmAllButton }, "Confirm All"),
                    React.createElement(Grid, { item: true, md: 12, className: classes.listItemsDiv, style: { height: previewHeight - 90 - 40 - 40 - 40 - (isConfirmAllExist ? 33 : 0) } },
                        React.createElement(Grid, { container: true, className: classes.listItemsContainer }, listData.map((data) => (React.createElement(Button, { className: classes.listItemsButton },
                            React.createElement(Grid, { item: true, md: 12 },
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, md: 10 },
                                        React.createElement(Grid, { container: true, alignItems: "center" },
                                            React.createElement(Grid, { item: true, md: 3, className: classes.listItemsButtonQuantity }, data.quantity + " pc"),
                                            React.createElement(Grid, { item: true, md: 2 },
                                                React.createElement(Grid, { container: true, justifyContent: "center" },
                                                    React.createElement(LabelOutlinedIcon, null))),
                                            React.createElement(Grid, { item: true, md: 6 },
                                                React.createElement(Grid, { item: true, md: 5, className: classes.listItemsButtonBoxTitle }, "Box"),
                                                React.createElement(Grid, { item: true, md: 5, className: classes.listItemsButtonBox }, data.box1Value),
                                                React.createElement(Grid, { item: true, md: 5, className: classes.listItemsButtonBox }, data.box2Value)))),
                                    React.createElement(Grid, { container: true, item: true, md: 2, alignItems: "center", justifyContent: "flex-end", style: { color: "#2d9dd5" } },
                                        React.createElement(EditIcon, null))))))))))),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Back")),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "right" }, "Next")))));
};
PickPackConfirmItemPage.defaultProps = {
    scanContentBarText: "Please scan box..."
};
export default React.memo(PickPackConfirmItemPage);
